import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { env } from '../../configs/EnvironmentConfig'

export const initialState = {
	uid: null,
	roles: [],
	token: localStorage.getItem(AUTH_TOKEN) || null,
	profile: null,
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
}

const path = (baseUrl, endpoint) => {
	return `${baseUrl}/auth-service/v1/${endpoint}`;
};

export const loginUser = createAsyncThunk('/loginUser', async (data) => {
	const url = path(env.AUTH_SERVICE, 'login-user');
	const response = await fetch(url, {
		method: 'POST',
		headers: {
			Authorization: '9fe1d3d18ca04ece2565f4ee4f86744fdaae3e7f5419c3bac554b76f09ce2d77',
			Accept: 'application/json',
			'Content-Type': 'application/json',
			client: 'mission-control',

		},
		body: JSON.stringify(data)
	})
	return response.json();
});

export const logoutUser = createAsyncThunk('/logoutUser', async (data) => {
	const url = path(env.AUTH_SERVICE, 'logout-user');
	const response = await fetch(url, {
		method: 'DELETE',
		headers: {
			Authorization: '9fe1d3d18ca04ece2565f4ee4f86744fdaae3e7f5419c3bac554b76f09ce2d77',
			Accept: 'application/json',
			'Content-Type': 'application/json',
			client: 'mission-control',

		},
		body: JSON.stringify({token: localStorage.getItem(AUTH_TOKEN)})
	})
	console.log('Logout successful');
	return response.json();
});

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(loginUser.pending, (state) => {
				state.loading = true
			})
			.addCase(loginUser.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.uid = action.payload.uid
				state.roles = action.payload.roles
				state.token = action.payload.auth.token
				state.profile = action.payload.user
				localStorage.setItem(AUTH_TOKEN, state.token)
			})
			.addCase(loginUser.rejected, (state, action) => {
				state.message = action.payload.message
				state.showMessage = true
				state.loading = false
			})
			.addCase(logoutUser.fulfilled, (state) => {
				state.loading = false
				state.uid = null
				state.roles = []
				state.token = null
				state.profile = null
				localStorage.removeItem(AUTH_TOKEN);
				state.redirect = '/'
			})
	},
})

export const {
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer
